import { Component } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'demo-upp-header',
    templateUrl: './demo-upp-header.html',
    styleUrls: ['../demo-common.scss', './demo-upp-header.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoUppHeaderComponent {
    dynamicColor = 'primary';
    colors = ['primary', 'success', 'warning', 'danger'];

    cycleColor() {
        const idx = this.colors.indexOf(this.dynamicColor);
        this.dynamicColor = this.colors[(idx + 1) % this.colors.length];
    }
}
